export const PencilIcon = ({
  className,
  width,
  height,
}: {
  className?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.0892 0.60911C11.3958 0.482113 11.7244 0.416748 12.0562 0.416748C12.3881 0.416748 12.7167 0.482113 13.0233 0.60911C13.3299 0.736107 13.6085 0.92225 13.8432 1.15691C14.0778 1.39156 14.264 1.67014 14.391 1.97675C14.5179 2.28334 14.5833 2.61195 14.5833 2.94381C14.5833 3.27566 14.5179 3.60427 14.391 3.91087C14.264 4.21747 14.0778 4.49605 13.8432 4.7307L13.4761 5.09773L9.90234 1.52393L10.2693 1.15691C10.504 0.92225 10.7826 0.736107 11.0892 0.60911Z"
        fill="currentColor"
      />
      <path
        d="M8.90074 2.52563L1.58876 9.83762C1.50159 9.92474 1.43868 10.0332 1.40625 10.1521L0.441723 13.6887C0.374842 13.9339 0.444492 14.1962 0.624232 14.3759C0.803971 14.5557 1.06624 14.6253 1.31147 14.5584L4.84806 13.5939C4.96699 13.5615 5.07539 13.4986 5.16255 13.4114L12.4745 6.09946L8.90074 2.52563Z"
        fill="currentColor"
      />
    </svg>
  );
};
